module.exports = __webpack_public_path__ + "img/matr1x_fire_intro_banner_m.a22eba5c.webp";